import { useCallback, useContext, useEffect } from 'react';
import COOKIES from '~/constants/cookies';
import StaticContext from '~/context/common/StaticContext';
import TradeContext from '~/context/common/TradeContext';
import TradeInPreviewAcquisition from '~/contracts/common/Trade';
import fetchTradeInPreviewAcquisitions from '~/services/common/fetchTradeInPreviewAcquisitions';
import { BrowserCookies } from '~/utilities';
import { generateErrorLogger } from '~/utilities/loggers';

export default function useGetTrades(isLoggedIn: boolean) {
  const {
    trades: { setLoading, setData, setError, setLoaded },
    setSelectedTrade
  } = useContext(TradeContext);
  const { eventCorrelationId } = useContext(StaticContext);

  const handleMultipleTrades = useCallback(
    (trades: TradeInPreviewAcquisition[]) => {
      const preferredTradeAcquisitionName =
        BrowserCookies.get(COOKIES.preferredTrade) ?? '';
      const preferredTrade = trades.find(
        a => a.id === preferredTradeAcquisitionName
      );

      if (preferredTrade) {
        setSelectedTrade(preferredTrade);
      } else {
        BrowserCookies.set(COOKIES.preferredTrade, trades[0].id, {
          expires: 365
        });
        setSelectedTrade(trades.at(0) ?? null);
      }
    },
    [setSelectedTrade]
  );

  useEffect(() => {
    if (!isLoggedIn) {
      setLoaded();

      return;
    }

    setLoading();
    fetchTradeInPreviewAcquisitions(eventCorrelationId)
      .then(trades => {
        if (trades.length > 1) {
          handleMultipleTrades(trades);
        } else {
          setSelectedTrade(trades.at(0) ?? null);
          BrowserCookies.remove(COOKIES.preferredTrade);
        }

        setData(trades);
      })
      .catch(generateErrorLogger('Get trades', {}, { callback: setError }));
  }, [
    eventCorrelationId,
    handleMultipleTrades,
    isLoggedIn,
    setData,
    setError,
    setLoaded,
    setLoading,
    setSelectedTrade
  ]);
}
